export default class CreateAllocationsPinnedTopRowData {
  execute(projectAllocation, capacity, translations) {
    const columns = Object.keys(projectAllocation.calculated[0].values);
    const employeeColumns = projectAllocation.columns.filter(
      (columnData) => !['PLAN', 'FACT', 'Total plan', 'Total fact'].includes(columnData.name),
    );
    const capacityValues = capacity.items[0].values;

    const resultArray = [
      {
        ...employeeColumns.reduce(
          (a, v) => ({
            ...a,
            [`${v.columnId}-p`]: v.name,
          }),
          {},
        ),
        name: translations('capacitiesPage.employee'),
        colSpan: 2,
        nameCellClass: 'row-header-cell',
        cellClass: 'employee-row-cell',
        editable: () => false,
      },
      {
        ...employeeColumns.reduce(
          (a, v) => ({
            ...a,
            [`${v.columnId}-p`]: capacityValues[v.columnId],
          }),
          {},
        ),
        name: translations('capacitiesPage.capacity'),
        colSpan: 2,
        nameCellClass: 'capacity-row-header-cell',
        cellClass: 'capacity-row-cell',
        transformColumnId: (columnId) => columnId.slice(0, -2),
        onCellValueChanged: (event) => this.handleCapacityCellValueChangedClick(event),
        editable: (params) => params.colDef.field !== 'name',
      },
      {
        ...columns.reduce(
          (a, v) => ({
            ...a,
            [v]: translations(`capacitiesPage.${v.endsWith('p') ? 'plan' : 'fact'}`),
          }),
          {},
        ),
        name: '',
        nameCellClass: 'row-header-cell',
        cellClass: 'description-row-cell',
        editable: () => false,
      },
    ];

    projectAllocation.calculated.forEach((row) => {
      row.values.name = row.name;
      row.values.immutable = true;
      row.values.editable = () => false;
      row.values.nameCellClass = 'row-header-cell';
      resultArray.push(row.values);
    });

    const utilization = resultArray.find((row) => row.name === 'Utilization');
    utilization.name = translations('capacitiesPage.utilization');
    utilization.format = (params) => (params.value === '-' ? '' : `%`);
    utilization.cellClass = (params) => {
      let res = 'text-center ';

      const numericValue = Number(params.value);
      if (!isNaN(numericValue)) {
        if (numericValue > 100) {
          res += 'cell-red-color';
        } else if (numericValue < 80) {
          res += 'cell-yellow-color';
        } else {
          res += 'cell-green-color';
        }
      }

      return res;
    };

    const workingHours = resultArray.find((row) => row.name === 'Working Hours');
    workingHours.name = translations('capacitiesPage.workingHours');
    workingHours.format = `H`;
    workingHours.cellClass = 'text-center';

    projectAllocation.calculated.find;
    return resultArray;
  }
}
